import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { AppUser } from '@aveespa/common/models/auth/app-user.interface';
import { UserService } from 'app/@core/user/user.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        NgClass,
        MatDividerModule,
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: AppUser;

    private readonly _avatarPalette = [
        'bg-indigo-500', 'bg-violet-500', 'bg-blue-500',
        'bg-teal-500',   'bg-rose-500',   'bg-amber-600',
    ];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
    ) {}

    ngOnInit(): void {
        this._userService.appUser$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: AppUser) => {
                this.user = user;
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    getInitials(user: AppUser): string {
        return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
    }

    getAvatarBgClass(user: AppUser): string {
        const seed = (user.firstName + user.lastName).charCodeAt(0) % this._avatarPalette.length;
        return this._avatarPalette[seed];
    }

    // TODO(mvp): unused — Profile menu item is hidden until the self-service profile
    // page ships (docs/backlog/MODULE-2-V2-BACKLOG.md BL2-04). Kept for that build-out.
    navigateToProfile(): void {
        this._router.navigate(['/profile/notifications']);
    }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }
}
